export const calculateScrollOffset = (item: HTMLElement, container: HTMLElement) => {
  const scrollOffset = container.scrollTop;
  const activeItemTopOffset = item.offsetTop;
  const activeItemBottomOffset = item.offsetTop + item.scrollHeight - container.clientHeight;

  if (activeItemTopOffset < scrollOffset) {
    return activeItemTopOffset;
  } else if (activeItemBottomOffset > scrollOffset) {
    return activeItemBottomOffset;
  }

  return scrollOffset;
};
